<template>
    <!-- Modal -->
    <b-modal
        v-model="modal.ver"
        :title="accion + ' licencia'"
        size="xl"
        id="bv-modal-create-or-update-lisences"
        scrollable
    >

        <!-- Tabs header -->
        <div class="mt-2 licenses-tabs px-3">
            <button
                role="button"
                @click="setactivedTabMonthlyPayment(1)"
                class="licenses-tabs-item"
                :class="{ 'active': activedTabMonthlyPayment === 1 }"
            >
                <span>Datos de la licencia</span>
            </button>
            <button
                role="button"
                @click="onHandleViewMonthlyLicensesPayments"
                class="licenses-tabs-item"
                :class="{ 'active': activedTabMonthlyPayment === 2 }"
                v-if="accion == 'Actualizar'"
            >
                <span>Tabla de pagos por mes</span>
            </button>
        </div>

        <!-- Tabs content -->
        <div class="mt-4 licenses-tabs px-3">

            <!-- Formulario de crear o actualizar -->
            <div v-if="activedTabMonthlyPayment === 1">
                <!-- Formulario -->
                <form @submit.prevent="onHandleStore" data-vv-scope="licencias">

                    <h5 class="mb-2"><strong>Datos generales</strong></h5>
                    <b-row>
                        <b-col md="4" lg="4" sm="12">
                            <b-form-group>
                                <label for="fechas">Fechas</label>
                                <el-date-picker v-model="licencia.fechas" id="fechas" name="fechas" type="daterange"
                                    size="small" class="w-100" :clearable="false" range-separator="-"
                                    start-placeholder="Fecha de inicio" end-placeholder="Fecha de fin"
                                    :picker-options="opciones" format="yyyy-MM-dd" value-format="yyyy-MM-dd" data-vv-as=" "
                                    v-validate="'required'" />
                                <div class="text-danger span-error small" v-text="errors.first('licencias.fechas')" />
                            </b-form-group>
                        </b-col>
                        <b-col md="4" lg="4" sm="12">
                            <b-form-group>
                                <label for="fechas">Cantidad de productos</label>
                                <b-form-input type="number" id="precio" name="precio" v-model="licencia.number_products" data-vv-as=" "
                                    v-validate="{
                                            rules: {
                                                integer: true,
                                                min_value: 0,
                                            }
                                        }" />
                                <div class="text-danger span-error small" v-text="errors.first('licencias.number_products')" />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group>
                                <label for="observaciones" class="w-100">
                                    Observaciones
                                </label>
                                <b-form-textarea id="observaciones" name="observaciones" v-model="licencia.observaciones"
                                    data-vv-as=" " v-validate="'min:3|max:255'" />
                                    <div class="d-flex justify-content-between alig-items-center">
                                        <div class="text-danger span-error small" v-text="errors.first('licencias.observaciones')" />
                                        <small :class="{ 'text-danger': getQuantityTextAreaLenght > 255, 'text-success': getQuantityTextAreaLenght <= 255 }">
                                            {{ getQuantityTextAreaLenght }} caracteres de 255 permitidos.
                                        </small>
                                    </div>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <h5 class="my-2"><strong>Control de usuarios</strong></h5>
                    <b-row>
                        <b-col md="2" lg="2" sm="6">
                            <b-form-group>
                                <label for="usuarios_multiusuarios" class="w-100">
                                    Multiusuarios
                                </label>
                                <b-form-radio-group id="usuarios_multiusuarios" name="usuarios_multiusuarios"
                                    v-model="licencia.usuarios_multiusuarios" class="mini" data-vv-as=" " size="mini"
                                    v-validate="'required'" :options="opciones_si_no" buttons
                                    :button-variant="licencia.usuarios_multiusuarios ? 'outline-primary' : 'outline-secondary'" />
                            </b-form-group>
                        </b-col>
                        <b-col md="2" lg="2" sm="6">
                            <b-form-group>
                                <label for="cantidad_usuarios" class="w-100">
                                    Cantidad usuarios
                                </label>
                                <el-input-number v-model="licencia.cantidad_usuarios" id="cantidad_usuarios"
                                    name="cantidad_usuarios" size="small" :min="1" :max="1000" data-vv-as=" "
                                    v-validate="'required|integer|min_value:1|max_value:1000'" />
                                <div class="text-danger span-error small"
                                    v-text="errors.first('licencias.cantidad_usuarios')" />
                            </b-form-group>
                        </b-col>
                        <b-col md="2" lg="2" sm="6">
                            <b-form-group>
                                <label for="usuarios_contratistas" class="w-100">
                                    Usuarios contratistas
                                </label>
                                <b-form-radio-group id="usuarios_contratistas" name="usuarios_contratistas"
                                    v-model="licencia.usuarios_contratistas" data-vv-as=" " size="mini" v-validate="'required'"
                                    :options="opciones_si_no" buttons
                                    :button-variant="licencia.usuarios_contratistas ? 'outline-primary' : 'outline-secondary'" />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <h5 class="my-2"><strong>Tipo y precios</strong></h5>
                    <b-row>
                        <b-col md="4" lg="4" sm="12">
                            <b-form-group>
                                <label for="modalidad_pago" class="w-100">
                                    Modalidad de pago
                                </label>
                                <el-select id="modalidad_pago" name="modalidad_pago" v-model="licencia.modalidad_pago"
                                    data-vv-as=" " size="sm" v-validate="'required'">
                                    <el-option v-for="modalidad in modalidades" :label="modalidad.lista" :key="modalidad.lista"
                                        :value="modalidad.id" />
                                </el-select>
                                <div class="text-danger span-error small" v-text="errors.first('licencias.modalidad_pago')" />
                            </b-form-group>
                        </b-col>
                        <b-col md="3" lg="3" sm="12" v-if="showField">
                            <b-form-group>
                                <label for="valor_cargue" class="w-100">
                                    Valor cargue
                                </label>
                                <b-form-input type="number" id="valor_cargue" name="valor_cargue"
                                    v-model="licencia.valor_cargue" data-vv-as=" " v-validate="{
                                            rules: {
                                                required: true,
                                                decimal: 1,
                                                min_value: 0,
                                            }
                                        }" />
                                <div class="text-danger span-error small" v-text="errors.first('licencias.valor_cargue')" />
                            </b-form-group>
                        </b-col>
                        <b-col md="3" lg="3" sm="12" v-else>
                            <b-form-group>
                                <label for="precio" class="w-100">
                                    Precio
                                </label>
                                <b-form-input type="number" id="precio" name="precio" v-model="licencia.precio" data-vv-as=" "
                                    v-validate="{
                                            rules: {
                                                required: true,
                                                integer: true,
                                                min_value: 0,
                                                max_value: 100000000
                                            }
                                        }" />
                                <div class="text-danger span-error small" v-text="errors.first('licencias.precio')" />
                            </b-form-group>
                        </b-col>
                        <b-col md="2" lg="2" sm="12" v-if="isLicensePaymentMethod">
                            <b-form-group>
                                <label for="horas" class="w-100">
                                    Horas
                                </label>
                                <b-form-input type="number" id="horas" name="horas" v-model="licencia.horas" data-vv-as=" "
                                    v-validate="{
                                            rules: {
                                                required: isLicensePaymentMethod,
                                                integer: true,
                                            }
                                        }" />
                                <div class="text-danger span-error small" v-text="errors.first('licencias.horas')" />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <h5 class="my-2"><strong>Responsable</strong></h5>
                    <b-row>
                        <b-col md="4" lg="4" sm="12">
                            <b-form-group>
                                <label for="responsible_user" class="w-100">
                                    Asignar responsable
                                </label>
                                <el-select id="responsible_user" name="responsible_user" v-model="licencia.responsible_user_id"
                                    filterable remote clearable no-data-text="No hay datos que coincidan"
                                    no-match-text="No hay datos que coincidan" :remote-method="searchRemoteResponsible">
                                    <el-option v-for="user in responsibles" :key="user.id" :label="user.name"
                                        :value="user.id" />
                                </el-select>
                                <div class="text-secondary small">Será el responsable de aprobar el contrato de licencia para el
                                    uso de Soluquim.</div>
                                <div class="text-danger span-error small" v-text="errors.first('licencias.modalidad_pago')" />
                            </b-form-group>
                        </b-col>
                        <b-col md="8" lg="8" sm="12">
                            <b-form-group>
                                <label for="responsible_user" class="w-100">
                                    Aceptación de licenciamiento
                                </label>
                                <b-form-radio-group id="is_license_accepted" name="is_license_accepted"
                                    v-model="licencia.is_license_accepted" data-vv-as=" " size="mini"
                                    :options="[licencia.is_license_accepted ? 'Si, aprobado' : 'No, aprobado']" buttons
                                    :button-variant="licencia.is_license_accepted ? 'outline-primary' : 'secondary'" disabled>
                                </b-form-radio-group>
                                <div class="text-secondary small">Estado del contrato de licencia para Soluquim (el responsable
                                    acepto o no la licencia).</div>
                            </b-form-group>
                        </b-col>
                    </b-row>

                </form>
            </div>

            <!-- Listado de adicionales (Pagos por rangos de fechas) -->
            <div v-if="activedTabMonthlyPayment === 2 && accion == 'Actualizar'">

                <!-- Formulario -->
                <MonthlyPaymentsFormUpdateOrCreate />

                <!-- Historico -->
                <MonthlyPaymentsHistory />

            </div>

        </div>

        <!-- Footer modal-->
        <template #modal-footer>
            <div class="w-100 d-flex justify-content-end align-items-center">
                <b-button type="buttom" variant="secondary" @click="$bvModal.hide('bv-modal-create-or-update-lisences')">
                    <i class="fa fa-close mr-1" /> {{ activedTabMonthlyPayment === 1 ? 'Cancelar' : 'Cerrar'}}
                </b-button>
                <b-button v-if="activedTabMonthlyPayment === 1" type="buttom" variant="primary" @click="onHandleStore" class="ml-2">
                    <i class="fa fa-save mr-1" /> Guardar cambios
                </b-button>
            </div>
        </template>

    </b-modal>
</template>

<script>

// Generales
import { mapActions, mapState, mapMutations } from 'vuex';

// Componentes
import ToggleCheckComponent from '../../../shared/components/Toggle-check.vue';
import MonthlyPaymentsFormUpdateOrCreate from './monthly-payments/form.vue'
import MonthlyPaymentsHistory from './monthly-payments/history.vue'

export default {
    name: 'formulario',
    props: ['responsibles'],
    components: {
        ToggleCheckComponent,
        MonthlyPaymentsFormUpdateOrCreate,
        MonthlyPaymentsHistory
    },
    data() {
        return {
            opciones_si_no: [
                { text: 'Si', value: 1 },
                { text: 'No', value: 0 },
            ],
            opciones: {
                shortcuts: [
                    {
                        text: 'Último mes',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: 'Últimos 3 meses',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: 'Últimos 6 meses',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: 'Último año',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 360);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    computed: {
        // Licencias.
        ...mapState('licencias', [
            'licencia',
            'modalidades',
            'modal',
            'accion',
        ]),
        ...mapState('empresa', [
            'selectedEmpresa',
        ]),
        // Pagos mensuales de las licencias.
        ...mapState('monthlyPayments', [
            'monthlyPayments',
            'activedTabMonthlyPayment',
            'filter'
        ]),
        /**
         * Para modalidad de pago: Plan de Trabajo.
         *
         * @author Fernando Claros
         */
        showField() {
            const id_modalidad = this.licencia.modalidad_pago;

            return !!this.modalidades.find(m => m.id === id_modalidad && m.codigo === 'fdp002');
        },
        /**
         * Para modalidad de pago Licencia.
         *
         * @author Fernando Claros
         */
        isLicensePaymentMethod() {
            let isLicense = false;
            const paymentMethod = this.modalidades.find(x => x.id === this.licencia.modalidad_pago);
            if (!paymentMethod) return false;

            this.modalidades.find(m => {
                if (m.codigo == paymentMethod.codigo && paymentMethod.codigo == "fdp001") isLicense = true;
            });

            if (isLicense) return true;
        },
        /**
         * Obtener la cantidad de caracteres del textarea.
         *
         * @author Fernando Claros
         */
        getQuantityTextAreaLenght() {
            return typeof this.licencia.observaciones === 'string' ? this.licencia.observaciones.length : 0;
        }
    },
    methods: {
        // Licencias
        ...mapActions('licencias', [
            'crearLicencia',
            'actualizarLicencia',
            'loadResponsibles',
            'establecerLicencia'
        ]),
        ...mapMutations('licencias', [
            'establecerLicencia'
        ]),
        // Pagos mensuales de las licencias
        ...mapActions('monthlyPayments', ['getAllByCompany']),
        ...mapMutations('monthlyPayments', [
            'setActivedTabMonthlyPayment',
            'setDefaultMonthlyPayment',
            'setIsShowFormMonthlyPayment'
        ]),
        /**
         * Buscar responsables.
         *
         * @param string param
         * @author Fernando Claros
         */
        async searchRemoteResponsible(param = "") {
            if (param.length < 3) {
                this.responsibles = [];
                return false;
            }
            if (this.loading) return false;

            await this.loadResponsibles({
                companyId: this.selectedEmpresa.id,
                responsible_user: param
            });
        },
        /**
         * Crear o actualizar licencias.
         *
         * @author Fernando Claros
         */
        async onHandleStore() {

            if (this.showField) { // plan de trabajo
                this.establecerLicencia({
                    ...this.licencia,
                    precio: parseFloat(0),
                    horas: parseFloat(0)
                });
            } else if (this.isLicensePaymentMethod) { // licencia
                this.establecerLicencia({
                    ...this.licencia,
                    valor_cargue: parseFloat(0)
                });
            } else { // valor agregado

                let price = this.licencia.precio == null || this.licencia.precio == '' || this.licencia.precio == undefined ? 0 : this.licencia.precio;

                this.establecerLicencia({
                    ...this.licencia,
                    valor_cargue: parseFloat(0),
                    horas: parseFloat(0),
                    precio: parseFloat(price)
                });
            }

            await this.$validator.validateAll('licencias')
                .then(async (validado) => {
                    if (validado) {
                        if (this.accion === 'Crear') {
                            await this.crearLicencia();
                        } else {
                            await this.actualizarLicencia();
                        }
                    }
                });
        },
        /**
         * Establecer un tab activo.
         *
         * @param Number nextTab
         * @author Fernando Claros
         */
        setactivedTabMonthlyPayment(nextTab = 1) {
            this.setActivedTabMonthlyPayment(nextTab);
        },
        /**
         * Ver el contenido del tab de pagos de la licencia.
         *
         * Cargar los pagos.
         *
         * @author Fernando Claros
         */
        async onHandleViewMonthlyLicensesPayments() {

            // Activamos el tab
            this.setactivedTabMonthlyPayment(2)

            // Limpiar el formulario
            this.setDefaultMonthlyPayment();
            this.setIsShowFormMonthlyPayment(false);

            // Cargar los pagos
            const payload = {
                idLicense: this.licencia.id,
                idCompany: this.selectedEmpresa.id,
                page: this.filter.page,
                sortBy: this.filter.sortBy,
                sort: this.filter.sort,
                per_page: this.filter.per_page
            };
            await this.getAllByCompany(payload);
        },
    }
};
</script>

<style scoped>
.el-input-number__increase {
    color: white;
    background: #097b83;
}

.el-input-number__decrease {
    color: white;
    background: #097b83;
}
.tab-content {
    border: 0px !important;
}
.licenses-tabs {
    border-bottom: none !important;
    padding: 0px;

}
.licenses-tabs-item  {
    background-color: #ffffff !important;
    color: #73818f;
    border: 0px !important;
    border-bottom: 3px solid #c9c9c9 !important;
    padding: 10px 0px !important;
    padding-right: 30px !important;
    margin-right: 2px !important;
}
.licenses-tabs-item.active, .licenses-tabs-item.show {
    color: #097b83 !important;
    font-weight: bold;
    border: 0px !important;
    background-color: #ffffff !important;
    border-bottom: 3px solid #097b83 !important;
}
.licenses-tabs-item,
.licenses-tabs-item button {
    outline: none !important;
}
</style>
